import React, { useState } from 'react'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import * as formik from 'formik';
import * as yup from 'yup';
import {
    Button,
    Flex,
    Heading,
    Text,
    Loader,
    TextField,
    View,
} from "@aws-amplify/ui-react";
export const FormActa = () => {
    const [next, setNext] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    const { Formik } = formik;
    const schema = yup.object().shape({
        NombreCom: yup.string().required("Este Campo es Obligatorio"),
        Correo: yup.string().required("Ingrese el correo").email("Correo no valido"),
        Telefono: yup.string().required("Este Campo es Obligatorio"),
        Guardar: yup.bool(),

    });


    return (
        <>
        <h1 style={{fontFamily:"roboto", fontWeight:"700", color:"#475569"}}>Identidad/Acta de Nacimiento</h1>
        <h3 style={{fontFamily:"roboto", fontWeight:"700", color:"#475569"}}>Expedición de la copia certificada del acta en línea</h3>
        <p style={{fontFamily:"roboto", fontWeight:"700", color:"#475569"}}>Documeto expedido por la direccion  de Registro Civil  que acredita el lugar, fecha de nacimiento y datos de filiación de una persona</p>
        <View padding="2rem" className='ViewActa'>
            {next === 1 ?
            <Formik
                validationSchema={schema}
                onSubmit={(valores, { resetForm }) => {
                    console.log("Valores", valores);
                    resetForm();
                    setNext(2);
                }

            }
            initialValues={{
                NombreCom: '',
                Correo: '',
                Telefono: '',
                Guardar: false,
                
            }}
            >
                {({ handleSubmit, handleChange, values, touched, errors }) => (
                    <Form noValidate onSubmit={handleSubmit} className='FormActa'>
                         <Row className='mb-3'>
                        <Form.Label style={{textAlign:"right", fontFamily: "Helvetica", fontWeight: "700", fontSize: "12px", color: "#2D3748", textDecoration: "underline" }}>Paso 1 de 2</Form.Label>
                    </Row>
                        <Row className="mb-3">
                            <Form.Group
                                as={Col}
                                className="position-relative"
                                controlId='NombreCom'
                                >
                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", fontSize: "20px", color: "#2D3748", textDecoration: "underline" }}>
                                    Nombre Completo del Solicitante
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="NombreCom"
                                    value={values.NombreCom}
                                    onChange={handleChange}
                                    isValid={touched.NombreCom && !errors.NombreCom}
                                    isInvalid={!!errors.NombreCom && touched.NombreCom}
                                    />
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.NombreCom}
                                </Form.Control.Feedback>
                            </Form.Group>

                        </Row>
                        <Row className="mb-3">

                            <Form.Group
                                as={Col}
                                controlId="Correo"
                                className="position-relative"
                                >
                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", fontSize: "20px", color: "#2D3748", textDecoration: "underline" }}>
                                    Correo electronico del solicitante
                                </Form.Label>
                                <Form.Control
                                    type="email"
                                    name="Correo"
                                    value={values.Correo}
                                    onChange={handleChange}
                                    isValid={touched.Correo && !errors.Correo}
                                    isInvalid={!!errors.Correo && touched.Correo}
                                    required
                                    />

                                <Form.Control.Feedback type="invalid" tooltip>{errors.Correo}</Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">

                            <Form.Group
                                as={Col}
                                controlId="Telefono"
                                className="position-relative"
                            >
                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", fontSize: "20px", color: "#2D3748", textDecoration: "underline" }}>
                                    Número de Teléfono del Solicitante
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="Telefono"
                                    value={values.Telefono}
                                    onChange={handleChange}
                                    isValid={touched.Telefono && !errors.Telefono}
                                    isInvalid={!!errors.Telefono && touched.Telefono}
                                />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.Telefono}</Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <Row className='mb-3'>
                            <Form.Group as={Col} className='position-relative'>
                                <Form.Check
                                    type="switch"
                                    name="Guardar"
                                    id="custom-switch"
                                    label="Recordar mis datos"
                                    value={values.Guardar}
                                    onChange={handleChange}
                                    />
                            </Form.Group>
                        </Row>
                  
                        <Row className="mb-3">
                            <Form.Group as={Col} className="d-grid gap-2">
                                <Button type="submit" style={{ backgroundColor: "#607472", color: "white" }}>
                                    {isLoading ?
                                        <>
                                            Loading
                                            <Loader
                                            />
                                        </>
                                        :
                                        <>
                                            Siguiente
                                            <svg width="20" height="20" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M23.4209 18.537C23.5726 18.3785 23.6915 18.1916 23.7709 17.987C23.9376 17.5813 23.9376 17.1261 23.7709 16.7204C23.6915 16.5158 23.5726 16.3289 23.4209 16.1704L18.4209 11.1704C18.107 10.8565 17.6814 10.6802 17.2375 10.6802C16.7937 10.6802 16.368 10.8565 16.0542 11.1704C15.7404 11.4842 15.5641 11.9098 15.5641 12.3537C15.5641 12.7975 15.7404 13.2232 16.0542 13.537L18.2209 15.687H12.2375C11.7955 15.687 11.3716 15.8626 11.059 16.1752C10.7465 16.4877 10.5709 16.9117 10.5709 17.3537C10.5709 17.7957 10.7465 18.2196 11.059 18.5322C11.3716 18.8448 11.7955 19.0204 12.2375 19.0204H18.2209L16.0542 21.1704C15.898 21.3253 15.774 21.5096 15.6894 21.7127C15.6048 21.9158 15.5612 22.1337 15.5612 22.3537C15.5612 22.5737 15.6048 22.7915 15.6894 22.9946C15.774 23.1977 15.898 23.3821 16.0542 23.537C16.2091 23.6932 16.3935 23.8172 16.5966 23.9018C16.7997 23.9865 17.0175 24.03 17.2375 24.03C17.4576 24.03 17.6754 23.9865 17.8785 23.9018C18.0816 23.8172 18.2659 23.6932 18.4209 23.537L23.4209 18.537ZM33.9042 17.3537C33.9042 14.0573 32.9267 10.835 31.0954 8.09418C29.264 5.35336 26.661 3.21715 23.6156 1.95569C20.5702 0.694233 17.219 0.364178 13.986 1.00726C10.753 1.65035 7.7833 3.2377 5.45242 5.56857C3.12155 7.89945 1.5342 10.8692 0.891115 14.1022C0.248028 17.3352 0.578083 20.6863 1.83954 23.7317C3.101 26.7772 5.23721 29.3802 7.97803 31.2115C10.7189 33.0429 13.9412 34.0204 17.2375 34.0204C21.6578 34.0204 25.897 32.2644 29.0226 29.1388C32.1483 26.0132 33.9042 21.774 33.9042 17.3537ZM3.9042 17.3537C3.9042 14.7166 4.68619 12.1387 6.15127 9.94608C7.61636 7.75343 9.69874 6.04446 12.1351 5.03529C14.5714 4.02612 17.2523 3.76208 19.8387 4.27655C22.4252 4.79102 24.8009 6.06089 26.6656 7.9256C28.5303 9.7903 29.8002 12.1661 30.3147 14.7525C30.8291 17.3389 30.5651 20.0198 29.5559 22.4561C28.5468 24.8925 26.8378 26.9749 24.6451 28.4399C22.4525 29.905 19.8746 30.687 17.2375 30.687C13.7013 30.687 10.3099 29.2823 7.80945 26.7818C5.30896 24.2813 3.9042 20.8899 3.9042 17.3537Z" fill="white" />
                                            </svg>
                                            </>

                                    }
                                </Button>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="d-grid gap-2">
                                <Button type="button" variation="secondary">
                                    Cancel
                                </Button>
                            </Form.Group>

                        </Row>
                    </Form>
                )}
            </Formik> 
            : next === 2 ?
            

            <FormActaData Formik={Formik} isLoading={isLoading} setNext={setNext} />
            : next === 3 ?
            <FormActaInfo setNext={setNext}/>: null
            
        }

        </View>

</>
    )
}

const FormActaData = (props) => {
    const { Formik, isLoading, setNext } = props;
    
    const schema2 = yup.object().shape({
        Nombre: yup.string().required("Este Campo es Obligatorio"),
        ApellidoP: yup.string().required("Este Campo es Obligatorio"),
        ApellidoM: yup.string().required("Este Campo es Obligatorio"),
        FechaNac: yup.date().required("Este Campo es Obligatorio"),
    });
    return (

        <Formik
            validationSchema={schema2}
            onSubmit={(valores, { resetForm }) => {
                console.log("Valores", valores);
                setNext(3);
            }

            }
            initialValues={{
                Nombre: '',
                ApellidoP: '',
                ApellidoM: '',
                FechaNac: '',
            }}
        >
            {({ handleSubmit, handleChange, handleReset, values, touched, errors }) => (
                <Form noValidate onSubmit={handleSubmit} className='FormActa' >
                    <Row className='mb-3'>
                    <Form.Label style={{textAlign:"right", fontFamily: "Helvetica", fontWeight: "700", fontSize: "12px", color: "#2D3748", textDecoration: "underline" }}>Paso 2 de 2</Form.Label>                    </Row>
                    <Row className="mb-3">
                        <Form.Group
                            as={Col}
                            controlId='Nombre'
                            className="position-relative"
                        >
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", fontSize: "20px", color: "#2D3748", textDecoration: "underline" }}>
                                Nombre (s)
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="Nombre"
                                value={values.Nombre}
                                onChange={handleChange}
                                isValid={touched.Nombre && !errors.Nombre}
                                isInvalid={!!errors.Nombre && touched.Nombre}
                            />
                            <Form.Control.Feedback type="invalid" tooltip>
                                {errors.Nombre}
                            </Form.Control.Feedback>
                        </Form.Group>

                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col} className='position-relative' controlId='ApellidoP'>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", fontSize: "20px", color: "#2D3748", textDecoration: "underline" }}>
                                Apellido Paterno
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='ApellidoP'
                                value={values.ApellidoP}
                                onChange={handleChange}
                                isValid={touched.ApellidoP && !errors.ApellidoP}
                                isInvalid={!!errors.ApellidoP && touched.ApellidoP}
                            />
                            <Form.Control.Feedback type="invalid" tooltip>{errors.ApellidoP}</Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col} className='position-relative' controlId='ApellidoM'>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", fontSize: "20px", color: "#2D3748", textDecoration: "underline" }}>
                                Apellido Materno
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='ApellidoM'
                                value={values.ApellidoM}
                                onChange={handleChange}
                                isValid={touched.ApellidoM && !errors.ApellidoM}
                                isInvalid={!!errors.ApellidoM && touched.ApellidoM}
                            />
                            <Form.Control.Feedback type="invalid" tooltip>{errors.ApellidoM}</Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group as={Col} className="postion-relative" controlId='FechaNac'>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", fontSize: "20px", color: "#2D3748", textDecoration: "underline" }}>
                                Fecha de Nacimiento
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control
                                    type="date"
                                    name="FechaNac"
                                    value={values.FechaNac}
                                    onChange={handleChange}
                                    isValid={touched.FechaNac && !errors.FechaNac}
                                    isInvalid={!!errors.FechaNac && touched.FechaNac}
                                />
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.FechaNac}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} className="d-grid gap-2">
                            <Text>Descripcion: Pulsa el boton para generar tu orden de pago.</Text>
                            <Button type="submit" style={{ backgroundColor: "#607472", color: "white" }} >
                                {isLoading ?
                                    <>
                                        Loading
                                        <Loader
                                        />
                                    </>
                                    :
                                    <>
                                        Siguiente
                                        <svg width="20" height="20" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M23.4209 18.537C23.5726 18.3785 23.6915 18.1916 23.7709 17.987C23.9376 17.5813 23.9376 17.1261 23.7709 16.7204C23.6915 16.5158 23.5726 16.3289 23.4209 16.1704L18.4209 11.1704C18.107 10.8565 17.6814 10.6802 17.2375 10.6802C16.7937 10.6802 16.368 10.8565 16.0542 11.1704C15.7404 11.4842 15.5641 11.9098 15.5641 12.3537C15.5641 12.7975 15.7404 13.2232 16.0542 13.537L18.2209 15.687H12.2375C11.7955 15.687 11.3716 15.8626 11.059 16.1752C10.7465 16.4877 10.5709 16.9117 10.5709 17.3537C10.5709 17.7957 10.7465 18.2196 11.059 18.5322C11.3716 18.8448 11.7955 19.0204 12.2375 19.0204H18.2209L16.0542 21.1704C15.898 21.3253 15.774 21.5096 15.6894 21.7127C15.6048 21.9158 15.5612 22.1337 15.5612 22.3537C15.5612 22.5737 15.6048 22.7915 15.6894 22.9946C15.774 23.1977 15.898 23.3821 16.0542 23.537C16.2091 23.6932 16.3935 23.8172 16.5966 23.9018C16.7997 23.9865 17.0175 24.03 17.2375 24.03C17.4576 24.03 17.6754 23.9865 17.8785 23.9018C18.0816 23.8172 18.2659 23.6932 18.4209 23.537L23.4209 18.537ZM33.9042 17.3537C33.9042 14.0573 32.9267 10.835 31.0954 8.09418C29.264 5.35336 26.661 3.21715 23.6156 1.95569C20.5702 0.694233 17.219 0.364178 13.986 1.00726C10.753 1.65035 7.7833 3.2377 5.45242 5.56857C3.12155 7.89945 1.5342 10.8692 0.891115 14.1022C0.248028 17.3352 0.578083 20.6863 1.83954 23.7317C3.101 26.7772 5.23721 29.3802 7.97803 31.2115C10.7189 33.0429 13.9412 34.0204 17.2375 34.0204C21.6578 34.0204 25.897 32.2644 29.0226 29.1388C32.1483 26.0132 33.9042 21.774 33.9042 17.3537ZM3.9042 17.3537C3.9042 14.7166 4.68619 12.1387 6.15127 9.94608C7.61636 7.75343 9.69874 6.04446 12.1351 5.03529C14.5714 4.02612 17.2523 3.76208 19.8387 4.27655C22.4252 4.79102 24.8009 6.06089 26.6656 7.9256C28.5303 9.7903 29.8002 12.1661 30.3147 14.7525C30.8291 17.3389 30.5651 20.0198 29.5559 22.4561C28.5468 24.8925 26.8378 26.9749 24.6451 28.4399C22.4525 29.905 19.8746 30.687 17.2375 30.687C13.7013 30.687 10.3099 29.2823 7.80945 26.7818C5.30896 24.2813 3.9042 20.8899 3.9042 17.3537Z" fill="white" />
                                        </svg>
                                    </>

                                }
                            </Button>
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} className="d-grid gap-2">
                            <Button type="button" variation="secondary" onClick={() => setNext(1)}>
                                Cancel
                            </Button>
                        </Form.Group>

                    </Row>
                </Form>
            )}
        </Formik>
    );


}


const FormActaInfo = (props) => {
    const { isLoading, setNext } = props;
    const { Formik } = formik;
    return (
        <Formik
            onSubmit={(valores, { resetForm }) => {
                console.log("Valores", valores);
              
            }

            }
            initialValues={{
                Codigo: '32456554',
                Curp: '',
                Nombre: '',
                Apellidos: '',
                Sexo: '',
                FechaNac: '',
                PaisNac: '',
                Municipio: '',
                Entidad: '',
                OficialiaNo: '',
                ActaNo: '',
                FechaReg: '',
                LocalidadOf: '',
                MunicipioOf: '',
                EntidadOf: '',
                NombreP: '',
                EdadP: '',
                NacionalidadP: '',
                NombreM: '',
                EdadM: '',
                NacionalidadM: '',


            }}
        >
            {({ handleSubmit, values, touched, errors }) => (
                <Form noValidate onSubmit={handleSubmit} style={{width:"80%", margin:"auto", textAlign:"left"}}>
                    <Row className='mb-3'>
                        <Button backgroundColor="#607472" color="white">PAGAR</Button>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group
                            as={Col}
                            className="position-relative"
                        >
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Código de Verfificación
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="Codigo"
                                value={values.Codigo}
                                disabled
                            />
                        </Form.Group>

                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col} className='position-relative'>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                CURP
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='Curp'
                                value={values.Curp}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col} className='position-relative'>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Nombre
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='Nombre'
                                value={values.Nombre}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col} className='position-relative'>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Apellidos
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='Apellidos'
                                value={values.Apellidos}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col} className='position-relative'>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700",  color: "#2D3748", textDecoration: "underline" }}>
                                Sexo
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='Sexo'
                                value={values.Sexo}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col} className='position-relative'>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Fecha de Nacimiento
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='FechaNac'
                                value={values.FechaNac}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col} className='position-relative' >
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                País de Nacimiento
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='PaisNac'
                                value={values.PaisNac}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col} className='position-relative'>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Municipio
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='Municipio'
                                value={values.Municipio}
                                disabled
                            />
                        </Form.Group>
                        <Form.Group as={Col} className='position-relative' >
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Entidad
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='Entidad'
                                value={values.Entidad}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", fontSize: "28px", color: "#2D3748", textDecoration: "underline" }}>
                            Datos de Oficialia
                        </Form.Label>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Oficialia No.
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='OficialiaNo'
                                value={values.OficialiaNo}
                                disabled
                            />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Acta No.
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='ActaNo'
                                value={values.ActaNo}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Fecha de Registro
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='FechaReg'
                                value={values.FechaReg}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Localidad
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='LocalidadOf'
                                value={values.LocalidadOf}
                                disabled
                            />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Localidad
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='MunicipioOf'
                                value={values.MunicipioOf}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Entidad
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='EntidadOf'
                                value={values.EntidadOf}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", fontSize: "28px", color: "#2D3748", textDecoration: "underline" }}>
                            Datos del Padre
                        </Form.Label>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Nombre
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='NombreP'
                                value={values.NombreP}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Edad
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='EdadP'
                                value={values.EdadP}
                                disabled
                            />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Nacionalidad
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='NacionalidadP'
                                value={values.NacionalidadP}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", fontSize: "28px", color: "#2D3748", textDecoration: "underline" }}>
                            Datos de la Madre
                        </Form.Label>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Nombre
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='NombreM'
                                value={values.NombreM}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Edad
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='EdadM'
                                value={values.EdadM}
                                disabled
                            />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                Nacionalidad
                            </Form.Label>
                            <Form.Control
                                type='text'
                                name='NacionalidadM'
                                value={values.NacionalidadM}
                                disabled
                            />
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} className="d-grid gap-2">
                            <Text>Descripcion: Pulsa el boton para generar tu orden de pago.</Text>
                            <Button type="submit" style={{ backgroundColor: "#607472", color: "white" }} >
                                {isLoading ?
                                    <>
                                        Loading
                                        <Loader
                                        />
                                    </>
                                    :   
                                    <>
                                        PAGAR
                                    </>

                                }
                            </Button>
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} className="d-grid gap-2">
                            <Button type="button" variation="secondary" onClick={() => window.location.href="/"}>
                                Cancel
                            </Button>
                        </Form.Group>

                    </Row>
                </Form>
            )}
        </Formik>
    );

}